<template lang="pug">
  .solicitud

    .title
      span(v-if="isEditing").little Modificando la solicitud {{ solicitud.id }}
      span(v-else-if="isExcepcion").little Ingresa una solicitud de permisos sin validaciones
      span(v-else) Ingresa una solicitud de permisos

      span.icon.close(
        @click="$emit('close')"
      )
        i.fa.fa-close

    transition-group.contenedor-datos(name="fade-smooth", tag="div")
      .indicaciones(v-if="mostrarIndicaciones && !isExcepcion", key="indicaciones")
        .title
          span Datos a tener en cuenta
          span.icon.close(
            @click="mostrarIndicaciones = false"
          )
            i.fa.fa-close
        ul.list
          li.list-item
            span La solicitud la debe aprobar&nbsp;
            strong
              i.fa.fa-spinner.fa-spin(v-if="isLoading")
              span(v-else) {{ jefe }}

      .contenedor-transaccion(key="transaccion")
        .contenedor-input-relative(v-if="isExcepcion")
          .control
            strong Codigo de empleado
            .datos
              input.input(
                type="number",
                v-model="codigoEmpleado"
              )
              span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaEmpleado = true")
                i.fa.fa-search
              .descripcion(v-if="nombreEmpleado")
                p {{ nombreEmpleado }}
          transition(name="fade-quick")
            .pop-over(
                v-if="mostrarBusquedaEmpleado"
              )
                lookup-small-empleado(
                  @selected="seleccionarEmpleado"
                  @close="mostrarBusquedaEmpleado = false"
                  :codigo="codigoEmpleado"
                )

        .contenedor-input-relative
          .control
            strong Tipo de permiso
            .datos
              input.input(
                type="number",
                v-model="tipo"
              )
              span.icon.cursor-pointer.margin-left-5(@click="mostrarBusquedaTipo = true")
                i.fa.fa-search
              .descripcion(v-if="descripcionTipo")
                p {{ descripcionTipo }}
          transition(name="fade-quick")
            .pop-over(
                v-if="mostrarBusquedaTipo"
              )
                lookup-small-tipos-permiso(
                  @selected="seleccionarTipo"
                  @close="mostrarBusquedaTipo = false"
                  :codigo="tipo"
                )

        br

        .motivo
          div
            strong Motivo
            textarea.textarea(
              v-model="motivo"
            )

        .title-detalle
          strong Ingrese las fechas y horas que se ausentará

        transition-group.contenedor-datos(name="fade-smooth", tag="div")
          .detalle(v-for="(o, index) in detalle", :key="'fechas_horas_permisos_'+index")
            .flex
              .control
                p(v-if="index === 0") Desde
                p.mobile-headers(v-else) Desde
                input.input(type="date" v-model="o.desde" pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}")
              .control
                p(v-if="index === 0") Hasta
                p.mobile-headers(v-else) Hasta
                input.input(type="date", v-model="o.hasta", pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}")
            .flex.jcc
              .control
                p(v-if="index === 0") Hora desde
                p.mobile-headers(v-else) Hora desde
                input.input(type="time", min="8:00" max="18:30", v-model="o.horaDesde")
              .control
                p(v-if="index === 0") Hora hasta
                p.mobile-headers(v-else) Hora hasta
                input.input(type="time", min="8:00" max="18:30", v-model="o.horaHasta")
              .delete-detalle
                span.icon(@click="eliminarDetalle(index)")
                  i.fa.fa-trash

        .agregar-linea
          button.button(
              @click="agregarDetalleVacio"
            )
              span.icon.is-small
                i.fa.fa-plus
              span Agregar linea

        .acciones
          button.button(
            @click="guardar(false)"
            :class="{ 'is-loading': isSaving }"
          )
            span.icon.is-small
              i.fa.fa-save
            span Guardar
          button.button(
            @click="guardar(true)"
            :class="{ 'is-loading': isSaving }"
            v-if="!isExcepcion"
          )
            span.icon.is-small
              i.fa.fa-check
            span Guardar y Enviar
</template>

<script>
import { apiGet, apiPost, notify } from '../util/general'
import LookupSmallTiposPermiso from './Component_Lookup_Small_Tipos_Permiso.vue'
import LookupSmallEmpleado from './Component_Lookup_Small_Empleado.vue'
export default {
  name: 'solicitud_permisos_component',
  components: {
    LookupSmallTiposPermiso,
    LookupSmallEmpleado
  },
  props: ['isEditing', 'solicitud', 'isExcepcion'],
  data () {
    return {
      tipo                    : '',
      descripcionTipo         : '',
      motivo                  : '',
      jefe                    : '',
      mostrarIndicaciones     : true,
      mostrarBusquedaTipo     : false,
      mostrarBusquedaEmpleado : false,
      codigoEmpleado          : '',
      nombreEmpleado          : '',
      empleadoExcepcion       : {},
      isSaving                : false,
      isLoading               : false,
      detalle                 : []
    }
  },
  watch : {
  },
  created () {
    this.fetchInfoJefe()
    // Si viene editando muestro los datos de la solicitud
    if (this.isEditing) {
      this.tipo            = this.solicitud.tipo
      this.descripcionTipo = this.solicitud.descripcionTipo
      this.motivo          = this.solicitud.motivo

      for (var i = 0; i < this.solicitud.detalle.length; i++) {
        var aux = {
          desde: window.moment(this.solicitud.detalle[i].desde, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          hasta: window.moment(this.solicitud.detalle[i].hasta, 'DD/MM/YYYY').format('YYYY-MM-DD'),
          horaDesde: this.solicitud.detalle[i].horaDesde,
          horaHasta: this.solicitud.detalle[i].horaHasta
        }
        this.detalle.push(aux)
      }
    } else {
      this.agregarDetalleVacio()
    }
  },
  methods: {
    fetchInfoJefe () {
      var vm = this
      vm.isLoading = true
      var obj = {
      }

      apiGet(vm, '/vacaciones/empleado/jefe', obj, function (data) {
        vm.jefe = data.data.nombre
      }, function (error) {
        notify(vm, 'error', 'Error', error.message)
      }, function () {
        vm.isLoading = false
      })
    },
    validar (obj, callback) {
      if (!obj.tipo) {
        callback(new Error('Por favor seleccione el tipo de permiso'))
        return
      }

      if (!obj.detalle) {
        callback(new Error('Por favor ingrese las fechas en que se ausentará'))
        return
      }

      if (obj.detalle.length === 0) {
        callback(new Error('Por favor ingrese las fechas en que se ausentará'))
        return
      }

      if (!obj.motivo) {
        callback(new Error('Por favor ingrese el motivo del permiso'))
        return
      }

      // var today = window.moment(window.moment().format('YYYY-MM-DD')).toDate()

      // Validaremos si es que hay datos iguales, no deberia haber
      var desde = []
      for (var i = 0; i < obj.detalle.length; i++) {
        // Validamos que la fecha de fin no sea antes de la fecha desde
        if (window.moment(obj.detalle[i].desde).isAfter(window.moment(obj.detalle[i].hasta))) {
          callback(new Error('La fecha hasta no puede ser anterior de la fecha desde'))
          return
        }

        var index = desde.indexOf(obj.detalle[i].desde)
        if (index === -1) {
          desde.push(obj.detalle[i].desde)
        } else {
          // Encontro un desde igual
          callback(new Error('No puedes ingresar fechas repetidas, por favor verifica'))
          return
        }

        // if (!obj.isExcepcion) {
        //   if (window.moment(obj.detalle[i].desde).isBefore(window.moment(today))) {
        //     callback(new Error('No puedes ingresar fecha anteriores a hoy'))
        //     return
        //   }
        // }
      }
      callback()
    },
    guardar (isSending) {
      var vm      = this
      vm.isSaving = true

      var obj = {
        tipo     : vm.tipo,
        motivo   : vm.motivo,
        isSending: isSending,
        detalle  : vm.detalle
      }

      if (vm.isEditing) {
        obj.id        = vm.solicitud.id
        obj.isEditing = vm.isEditing
      }

      if (vm.isExcepcion) {
        obj.isExcepcion = vm.isExcepcion
        obj.codigoEmpleado = vm.codigoEmpleado
      }

      // validamos
      vm.validar(obj, function (err) {
        if (err) {
          vm.isSaving = false
          notify(vm, 'error', 'Error', err.message)
          return
        }

        apiPost(vm, '/permisos/solicitud', obj, function (data) {
          vm.clear()
          notify(vm, 'success', 'Éxito', 'Guardado correctamente')
          if (vm.isEditing) {
            vm.$emit('closeRefresh')
          } else {
            vm.$emit('successNew')
          }
        }, function (error) {
          notify(vm, 'error', 'Error', error.message)
        }, function () {
          vm.isSaving = false
        })
      })
    },
    seleccionarTipo (o) {
      this.tipo = o.codigo
      this.descripcionTipo = o.descripcion
    },
    agregarDetalleVacio () {
      this.detalle.push({
        desde: window.moment().format('YYYY-MM-DD'),
        hasta: window.moment().format('YYYY-MM-DD'),
        horaDesde: '08:00',
        horaHasta: '18:00'
      })
    },
    eliminarDetalle (index) {
      this.detalle.splice(index, 1)
    },
    clear () {
      this.tipo            = ''
      this.descripcionTipo = ''
      this.motivo          = ''
      this.detalle         = []
      this.codigoEmpleado  = ''
      this.nombreEmpleado  = ''
    },
    seleccionarEmpleado (o) {
      this.codigoEmpleado = o.codigo
      this.nombreEmpleado = o.nombre
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
  .solicitud
    .close
      position absolute;
      top 3px;
      right 3px;
      cursor pointer
      i
        font-size 16px

    .title
      padding-right: 7px
      padding-left: 7px
      font-size 16px
      span
        font-weight bold
        text-transform uppercase
      .little
        font-size 14px

  .title-detalle
    padding 10px 0px

  .contenedor-datos
    display flex
    flex-direction column
    align-items center
    >*
      transition: all 0.5s;

    .contenedor-transaccion

      .delete-detalle
        display flex
        justify-content center
        align-items center
        color red
        i
          cursor pointer

      .detalle
        display flex
        flex-wrap: wrap;
        justify-content center
        .control
          padding 0px 10px 10px 10px

      .acciones
        display flex
        margin-top 10px
        .button
          flex 1
          margin 5px

  .indicaciones
    position relative
    flex 1
    padding 10px
    border 1px solid #209cee
    color: #12537e;
    background-color #f6fbfe
    display flex
    flex-direction column
    margin 10px
    width: 100%;

    strong
      color #209cee

    .close
      position absolute;
      top 1px;
      right 1px;
      cursor pointer
      i
        font-size 16px

    .title
      padding-right: 7px
      padding-left: 7px
      font-size 21px
      margin-bottom 5px

    .list
      display flex
      flex-direction column
      justify-content center
      flex 1
      text-align left
      .list-item
        padding-left 10px

  .contenedor-input-relative
    position relative
    .control
      text-align left
      .input
        width 100px


    .datos
      padding-top 5px
      display flex
      align-items center
      .descripcion
        padding-left 10px

  .pop-over
      background: #fff;
      border-radius: 3px;
      border: 1px solid #d6dadc;
      border-bottom-color: #c4c9cc;
      -webkit-box-shadow: 0 1px 6px rgba(0,0,0,.15);
      box-shadow: 0 1px 6px rgba(0,0,0,.15);
      position: absolute;
      width: 300px;
      z-index: 70;
      top 0

  .motivo
    .textarea
      min-height: 100px;

  .mobile-headers
    display none

  @media (max-width 638px)
    .detalle
      // border-bottom: 1px solid #0a0a0a1a;
      // margin-bottom: 10px;
      // &:last-child
      //   margin-bottom: 0px;
      //   border-bottom: none;
      &:not(:last-child)
        border-bottom: 1px solid #0a0a0a1a;
        margin-bottom: 10px;
    .mobile-headers
      display block
</style>



// WEBPACK FOOTER //
// Component_Permisos_Solicitud.vue?7cd3ed32